export default __webpack_public_path__ + "static/media/GalenkaLovelace.ae72c4a8.png";